import { Button, type ButtonProps } from "antd";

interface Props extends ButtonProps {}

export function PrimaryButton(props: Props) {
  return (
    <Button
      {...props}
      type="primary"
      style={{
        color: "#FFFFFF",
        width: "160px",
        height: "40px",
        background: "#165DFF",
      }}
    >
      {props.children}
    </Button>
  );
}

export function PrimaryOutlineButton(props: Props) {
  return (
    <Button
      {...props}
      variant="outlined"
      color="primary"
      style={{
        width: "160px",
        height: "40px",
      }}
    >
      {props.children}
    </Button>
  );
}
